<ng-template #contentTemplate>
  <ng-container [ngSwitch]="stepsList[currentStepIndex]">
    <div *ngSwitchCase="STEPS.USER_ROLE">
      <p *ngIf="totalSteps > 1" class="small-text" i18n>Step 1 of 3</p>
      <p nz-typography i18n>Please take a moment to answer a few quick questions about your company. Your response will help us create a better Motive experience.</p>
      <p nz-typography><strong i18n>Let's get started. What's your role?</strong></p>
      <form nz-form [formGroup]="userCompanyRoleForm" (ngSubmit)="submitUserCompanyRoleForm()">
        <nz-form-item>  
          <nz-form-control nzErrorTip="Please select a role" i18n-nzErrorTip>
            <nz-radio-group class="controls-group" formControlName="userCompanyRole">
              <ng-container *ngFor="let role of userRoles; let i = index; even as isEven">
                <div *ngIf="isEven" nz-row>
                  <div nz-col nzSpan="12">
                    <label nz-radio [nzValue]="role">{{role}}</label>
                  </div>
                  <div *ngIf="userRoles[i+1]" nz-col nzSpan="12">
                    <label nz-radio [nzValue]="userRoles[i+1]">{{userRoles[i+1]}}</label>
                  </div>
                </div>
              </ng-container>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control *ngIf="userCompanyRoleForm.get('userCompanyRole')?.value === 'Other'" nzErrorTip="Please specify your role" i18n-nzErrorTip>
            <span nz-typography><strong i18n>If other, please specify</strong></span>
            <input nz-input placeholder="Role" formControlName="userCompanyRoleInput" i18n-placeholder />
          </nz-form-control>
        </nz-form-item>
      </form>
    </div>

    <div *ngSwitchCase="STEPS.FOR_HIRE">
      <p class="small-text" i18n>Step 2 of 3</p>
      <p nz-typography><strong i18n>Are you a for-hire trucking company?</strong></p>
      <form nz-form [formGroup]="forHireForm" (ngSubmit)="submitForHireForm()">
        <nz-form-item>  
          <nz-form-control nzErrorTip="Please select an option" i18n-nzErrorTip>
            <nz-radio-group formControlName="forHire">
              <label nz-radio nzValue="true" i18n>Yes</label> 
              <label nz-radio nzValue="false" i18n>No</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </form>
    </div>

    <ng-container *ngSwitchCase="STEPS.COMPANY_TYPE">
      <div *ngIf="forHireForm.get('forHire')?.value === 'true'">
        <p class="small-text" i18n>Step 3 of 3</p>
        <span nz-typography><strong i18n>Last question! What type of freight do you primarily haul?</strong></span>
        <p nz-typography><strong i18n>You may select multiple.</strong></p>
        <nz-checkbox-wrapper class="controls-group" (nzOnChange)="onCompanySelectionChange($event)">
          <ng-container *ngFor="let role of companyRoles; let i = index; even as isEven">
            <div *ngIf="isEven" nz-row>
              <div nz-col nzSpan="12">
                <label nz-checkbox [nzValue]="role" [ngModel]="selectedCompanies.indexOf(role) > -1">{{role}}</label>
              </div>
              <div *ngIf="companyRoles[i+1]" nz-col nzSpan="12">
                <label nz-checkbox [nzValue]="companyRoles[i+1]" [ngModel]="selectedCompanies.indexOf(companyRoles[i+1]) > -1">{{companyRoles[i+1]}}</label>
              </div>
            </div>
          </ng-container>
        </nz-checkbox-wrapper>
        <p nz-typography nzType="danger">{{companyFormError}}</p>
        <form nz-form [formGroup]="frieghtForm" (ngSubmit)="submitFreightForm()">
          <nz-form-item>  
            <nz-form-control *ngIf="selectedCompanies.indexOf('Other') > -1" nzErrorTip="Please specify freight type" i18n-nzErrorTip>
              <span nz-typography><strong i18n>If other, please specify</strong></span>
              <input nz-input placeholder="Freight hauled" formControlName="freightInput" i18n-placeholder />
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>
      <div *ngIf="forHireForm.get('forHire')?.value === 'false'">
        <p class="small-text" i18n>Step 3 of 3</p>
        <p nz-typography><strong i18n>Last question! What type of work does your company do?</strong></p>
        <form nz-form [formGroup]="industryForm" (ngSubmit)="submitIndustryForm()">
          <nz-form-item>  
            <nz-form-control nzErrorTip="Please select a industry" i18n-nzErrorTip>
              <nz-radio-group class="controls-group" formControlName="industry">
                <ng-container *ngFor="let industry of industries; let i = index; even as isEven">
                  <div *ngIf="isEven" nz-row>
                    <div nz-col nzSpan="12">
                      <label nz-radio [nzValue]="industry">{{industry}}</label>
                    </div>
                    <div *ngIf="industries[i+1]" nz-col nzSpan="12">
                      <label nz-radio [nzValue]="industries[i+1]">{{industries[i+1]}}</label>
                    </div>
                  </div>
                </ng-container>
              </nz-radio-group>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item>
            <nz-form-control *ngIf="industryForm.get('industry')?.value === OTHER" nzErrorTip="Please specify your industry" i18n-nzErrorTip>
              <span nz-typography><strong i18n>If other, please specify</strong></span>
              <input nz-input placeholder="Industry" formControlName="industryInput" i18n-placeholder/>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #footerTemplate>
  <div>
    <button *ngIf="currentStepIndex > 0" nz-button (click)="currentStepIndex = currentStepIndex - 1" i18n>Previous</button>
    <button nz-button nzType="primary" (click)="nextStep()">{{currentStepIndex + 1 === totalSteps ? SUBMIT : NEXT}}</button>
  </div>
</ng-template>

<ng-template #closeIconTemplate>
  <svg   width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.793 10.5l-4.95-4.95.707-.707 4.95 4.95 4.95-4.95.707.707-4.95 4.95 4.95 4.95-.707.707-4.95-4.95-4.95 4.95-.707-.707 4.95-4.95z" fill="#757575"/></svg>
</ng-template>